import { render, staticRenderFns } from "./typingBar.vue?vue&type=template&id=5b63aad2&scoped=true&"
import script from "./typingBar.vue?vue&type=script&lang=js&"
export * from "./typingBar.vue?vue&type=script&lang=js&"
import style0 from "./typingBar.vue?vue&type=style&index=0&id=5b63aad2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b63aad2",
  null
  
)

export default component.exports